import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة المضاعف المشترك الأصغر";
const DESCRIPTION =
  "احسب المضاعف المشترك الأصغر (LCM) لأي مجموعة من الأعداد الصحيحة بسهولة وسرعة باستخدام هذه الآلة الحاسبة المتقدمة. اكتشف المضاعف المشترك الأصغر بين رقمين أو أكثر في ثوانٍ. أداة مثالية للطلاب، المعلمين، والمهندسين لحل المسائل الرياضية المعقدة التي تتطلب تحديد المضاعف المشترك الأصغر.";
const KEYWORDS =
  "مضاعف مشترك أصغر، LCM، آلة حاسبة، أعداد صحيحة، رياضيات، طلاب، معلمين، مهندسين.";
const OG_URL = "https://do-calculate.com/calculator/ar/lcm-calculator/";
const LCMCalculator = () => {
  const [numbers, setNumbers] = useState("");
  const [lcm, setLcm] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const primeFactors = (n) => {
    const factors = [];
    for (let i = 2; i <= n; i++) {
      while (n % i === 0) {
        factors.push(i);
        n = n / i;
      }
    }
    return factors;
  };
  const calculateLCM = (numArray) => {
    const gcd = (a, b) => (!b ? a : gcd(b, a % b));
    const lcm = (a, b) => (a * b) / gcd(a, b);
    return numArray.reduce((acc, num) => lcm(acc, num));
  };
  const handleCalculate = () => {
    try {
      if (!numbers) {
        throw new Error("الرجاء إدخال أرقام مفصولة بفواصل.");
      }
      const numArray = numbers.split(",").map(Number);
      if (numArray.some(isNaN)) {
        throw new Error("الرجاء إدخال أرقام صحيحة مفصولة بفواصل.");
      }
      const lcmValue = calculateLCM(numArray);
      const stepsArray = numArray.map((num) => {
        const factors = primeFactors(num);
        return `${num} = ${factors.join(" × ")}`;
      });
      const allFactors = numArray.flatMap((num) => primeFactors(num));
      const uniqueFactors = [...new Set(allFactors)];
      const lcmSteps = `LCM(${numArray.join(", ")}) = ${uniqueFactors.join(
        " × "
      )} = ${lcmValue}`;
      setLcm(lcmValue);
      setSteps([...stepsArray, lcmSteps]);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة المضاعف المشترك الأصغر</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بكم في{" "}
                  <strong>حاسبة المضاعف المشترك الأصغر (LCM)</strong>! هذه
                  الأداة المتطورة صُممت لتبسيط حساب المضاعف المشترك الأصغر لأي
                  مجموعة من الأعداد الصحيحة بسرعة ودقة. سواء كنت بحاجة لإيجاد
                  LCM لرقمين أو مجموعة من الأرقام، توفر لك هذه الآلة الحاسبة
                  حلًا فعالًا لمشكلتك الرياضية.
                </p>
                <p>
                  <strong>
                    لماذا تستخدم الآلة الحاسبة للمضاعف المشترك الأصغر؟
                  </strong>{" "}
                  المضاعف المشترك الأصغر هو أبسط عدد يمكن أن يقسم كل الأعداد في
                  مجموعة معينة دون باقي. يعتبر حسابه أمرًا أساسيًا في العديد من
                  التطبيقات الرياضية والهندسية. باستخدام أداتنا، يمكنك إجراء هذه
                  الحسابات المعقدة بسهولة ودقة، مما يوفر لك الوقت والجهد.
                </p>
                <p>
                  <strong>كيفية استخدام الأداة:</strong> كل ما عليك هو إدخال
                  الأعداد الصحيحة التي ترغب في حساب المضاعف المشترك الأصغر لها
                  في الحقول المخصصة، ثم اضغط على زر الحساب. ستتمكن من الحصول على
                  النتيجة الفورية في ثوانٍ، مما يساعدك في إنجاز مهامك الدراسية
                  أو المهنية بكفاءة.
                </p>
                <p>
                  <strong>مميزات الآلة الحاسبة:</strong>
                  <ul>
                    <li>
                      دقة في حساب المضاعف المشترك الأصغر لعدد كبير من الأرقام.
                    </li>
                    <li>واجهة مستخدم بسيطة وسهلة الاستخدام.</li>
                    <li>حسابات سريعة وفورية توفر الوقت والجهد.</li>
                    <li>
                      مثالية للطلاب والمعلمين والمهندسين لحل المسائل الرياضية
                      المعقدة.
                    </li>
                  </ul>
                </p>
                <p>
                  استخدم هذه الأداة المجانية عبر الإنترنت لتحسين مهاراتك
                  الرياضية وتسهيل عملك اليومي. استمتع بالحلول الدقيقة والسريعة
                  مع <strong>حاسبة المضاعف المشترك الأصغر</strong>!
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة المضاعف المشترك الأصغر
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          أدخل الأرقام مفصولة بفواصل
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="مثال: 12, 15, 20"
                        value={numbers}
                        onChange={(e) => setNumbers(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      lcm !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">
                            المضاعف المشترك الأصغر: {lcm}
                          </p>
                          <h4 className="text-white">الخطوات:</h4>
                          {steps.map((step, index) => (
                            <p key={index} className="text-white">
                              {step}
                            </p>
                          ))}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هو المضاعف المشترك الأصغر؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                المضاعف المشترك الأصغر (LCM) لعددين هو أصغر عدد يكون مضاعفاً
                مشتركاً لهما. بمعنى آخر، هو أصغر عدد يقبل القسمة على كلا العددين
                بدون باقي. على سبيل المثال، لنفترض أننا نريد حساب المضاعف
                المشترك الأصغر للعددين 4 و5.
              </p>
              <p>
                لتحديد المضاعف المشترك الأصغر، نبحث عن أصغر عدد يمكن أن يُقسم
                عليه كل من 4 و5. في هذه الحالة، المضاعف المشترك الأصغر هو 20،
                لأن 20 هو أصغر عدد يمكن قسمته على كل من 4 و5 بدون باقي.
              </p>
              <p>
                مثال آخر: المضاعف المشترك الأصغر للعددين 6 و8 هو 24، حيث أن 24
                هو أصغر عدد يمكن قسمته على كل من 6 و8 بدون باقي.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيفية حساب المضاعف المشترك الأصغر
              </h3>
            </div>
            <div className="info-section-body">
              <p>يمكن حساب المضاعف المشترك الأصغر باستخدام الطريقة التالية:</p>
              <ol>
                <li>
                  <strong>إيجاد العوامل الأولية:</strong> قم بتحليل كل عدد إلى
                  عوامله الأولية. على سبيل المثال، تحليل العددين 12 و18.
                </li>
                <li>
                  <strong>العوامل الأولية للعدد 12:</strong> 2 × 2 × 3.
                </li>
                <li>
                  <strong>العوامل الأولية للعدد 18:</strong> 2 × 3 × 3.
                </li>
                <li>
                  <strong>أخذ أكبر قوة لكل عامل:</strong> في هذه الحالة، نأخذ
                  2^2 و3^2.
                </li>
                <li>
                  <strong>مضاعفة العوامل:</strong> 2^2 × 3^2 = 4 × 9 = 36.
                </li>
              </ol>
              <p>لذا، المضاعف المشترك الأصغر للعددين 12 و18 هو 36.</p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>أهمية المضاعف المشترك الأصغر</h3>
            </div>
            <div className="info-section-body">
              <p>
                المضاعف المشترك الأصغر يلعب دوراً مهماً في العديد من التطبيقات
                الرياضية والهندسية، ومنها:
              </p>
              <ul>
                <li>
                  <strong>حل المسائل المتعلقة بالأعداد الكسرية:</strong> عند جمع
                  أو طرح الكسور التي تحتوي على مقامات مختلفة، يمكن استخدام
                  المضاعف المشترك الأصغر لتحديد المقام المشترك.
                </li>
                <li>
                  <strong>التنسيقات الزمنية:</strong> في حسابات الوقت مثل
                  الجدولة والتوقيت، قد تحتاج إلى معرفة المضاعف المشترك الأصغر
                  للأوقات لتنسيق الأحداث.
                </li>
                <li>
                  <strong>التطبيقات الهندسية:</strong> عند تصميم عناصر تتطلب
                  تنسيقاً دقيقاً، مثل الأسطح أو الأجزاء الميكانيكية، يمكن أن
                  يكون حساب المضاعف المشترك الأصغر مفيداً.
                </li>
              </ul>
              <p>
                فهم كيفية حساب واستخدام المضاعف المشترك الأصغر يساعد في تبسيط
                العديد من المسائل الرياضية والتطبيقات العملية في الحياة اليومية.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LCMCalculator;
